import format from 'date-fns/format';
import { makeStyles } from '@material-ui/core/styles';
import DownloadIcon from '@material-ui/icons/GetApp';
import ViewIcon from '@material-ui/icons/Visibility';
import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import ContentBox from 'components/CncUI/ContentBox';
import Tag from 'components/CncUI/Tag';

const useStyles = makeStyles(({ palette }) => ({
  tag: {
    marginLeft: 8,
  },
  box: {
    padding: '8px 24px',
    '&:hover': {
      background: palette.cncUI.primary.gray['+8'],
      '& svg': {
        color: palette.cncUI.default['-3'],
      },
    },
  },
  action: {
    cursor: 'pointer',
    color: 'transparent',
  },
}));

const HistoryDocument = ({ item, current, view, download }) => {
  const classes = useStyles();

  return (
    <ContentBox dense transparent className={classes.box}>
      <Grid container spacing={1} alignItems="center">
        <Grid item>
          <Typography component="span" variant="body2" size="long" noMargin>
            {format(new Date(parseInt(item.createdAt, 10)), 'LLLL d yyyy, p')}
          </Typography>
          {current && (
            <Tag className={classes.tag} color="teal">
              Current
            </Tag>
          )}
        </Grid>
        <Grid item style={{ flex: 1 }}>
          <Grid container spacing={2} justify="flex-end">
            <Grid item>
              <ViewIcon
                className={classes.action}
                onClick={() => view(item.documentId)}
              />
            </Grid>
            <Grid item>
              <DownloadIcon
                className={classes.action}
                onClick={() => download(item.documentId)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ContentBox>
  );
};

export default HistoryDocument;
